/* eslint-disable react-refresh/only-export-components -- thin context module: exporting context + hook is intentional */
import { createContext, useContext } from "react";

/** @type {React.Context<null | { user: object | null, setUser: (u: object | null) => void }>} */
export const UserSessionContext = createContext(null);

export function useUserSession() {
  return useContext(UserSessionContext);
}
